// Inline brand-faithful WhatsApp glyph (so we don't need an extra dependency).
export default function WhatsappIcon({ className = "w-5 h-5" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M19.11 4.91A10.05 10.05 0 0 0 12.06 2C6.55 2 2.07 6.48 2.07 11.99c0 2.11.55 4.17 1.6 5.99L2 22l4.16-1.62a10 10 0 0 0 5.9 1.9h.01c5.51 0 9.99-4.48 9.99-9.99a9.95 9.95 0 0 0-2.95-7.38ZM12.06 20.45h-.01a8.3 8.3 0 0 1-4.23-1.16l-.3-.18-2.47.96.96-2.41-.2-.31a8.27 8.27 0 0 1-1.27-4.36c0-4.58 3.73-8.31 8.32-8.31 2.22 0 4.31.87 5.88 2.44a8.27 8.27 0 0 1 2.43 5.89c0 4.58-3.73 8.31-8.31 8.31Zm4.56-6.22c-.25-.13-1.48-.73-1.71-.81-.23-.08-.4-.13-.56.13-.17.25-.65.81-.79.97-.15.17-.29.19-.54.06-.25-.13-1.05-.39-2-1.24-.74-.66-1.24-1.48-1.39-1.73-.15-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.13-.56-1.36-.77-1.86-.2-.49-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07s.89 2.4 1.02 2.57c.13.17 1.76 2.69 4.27 3.77.6.26 1.06.41 1.43.53.6.19 1.14.16 1.57.1.48-.07 1.48-.6 1.69-1.19.21-.59.21-1.09.15-1.19-.06-.1-.23-.16-.48-.29Z" />
    </svg>
  );
}
